import React, { useState } from "react";
import axios from "axios";

const ImageUploader = ({ setPreviewImgSrc }) => {
    const [preview, setPreview] = useState("https://via.placeholder.com/150");
    const [isUploading, setIsUploading] = useState(false);

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            setIsUploading(true); // Show uploading state

            try {
                const formData = new FormData();
                formData.append("file", file, file.name);

                // Upload image to the server
                const response = await axios.post(
                    `${process.env.REACT_APP_API_URL}/admin/blogs/image/upload`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (response.status === 200) {
                    const { location } = response.data;

                    // Update preview and parent state
                    setPreview(location);
                    setPreviewImgSrc(location);

                    console.log("Image uploaded successfully:", location);
                } else {
                    console.error("Failed to upload image.");
                    alert("Failed to upload image.");
                }
            } catch (error) {
                console.error("An error occurred while uploading the image:", error);
                alert("An error occurred while uploading the image.");
            } finally {
                setIsUploading(false); // Reset uploading state
            }
        }
    };

    return (
        <div className="d-flex flex-column align-items-center mb-3">
            <label htmlFor="fileInput" className="form-label fw-bold mb-2">
                Öngösterim Resmi:
            </label>
            <img
                src={preview}
                alt="Önizleme"
                className="rounded border shadow-sm mb-2"
                style={{ width: "150px", height: "150px", objectFit: "cover" }}
            />
            <input
                type="file"
                id="fileInput"
                accept="image/*"
                className="form-control w-50"
                onChange={handleFileChange}
                disabled={isUploading} // Disable input while uploading
            />
            {isUploading && (
                <div className="text-primary mt-2">
                    Resim yükleniyor, lütfen bekleyin...
                </div>
            )}
        </div>
    );
};

export default ImageUploader;
